import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent, ref, reactive, onMounted, toRefs } from 'vue';
import apis from "@/api";
export default defineComponent({
  components: {},
  setup(props, ctx) {
    const upload = ref(null);
    const addForm = ref(null);
    const newPermission = ref({
      menuType: 1
    });
    const data = reactive({
      iconChange: false,
      isEdit: false,
      loading: false,
      queryParam: {},
      tableData: [],
      menuList: [],
      addDialogShow: false,
      rules: {
        parentId: [{
          required: true,
          message: '请选择父级节点',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入权限名称',
          trigger: 'blur'
        }]
      }
    });
    const submit = () => {
      upload.value.submit();
      if (!data.iconChange) {
        submitData();
      }
    };
    const submitData = () => {
      addForm.value.validate(valid => {
        if (valid) {
          if (data.isEdit) {
            apis.editPermission(newPermission.value).then(res => {
              if (res.success) {
                loadPage();
                ElMessage.success('权限修改成功');
                data.addDialogShow = false;
              } else {
                ElMessage.error(res.msg);
              }
            });
          } else {
            apis.addPermission(newPermission.value).then(res => {
              if (res.success) {
                loadPage();
                ElMessage.success('权限新增成功');
                data.addDialogShow = false;
              } else {
                ElMessage.error(res.msg);
              }
            });
          }
        }
      });
    };
    const fileUpload = params => {
      const formData = new FormData();
      formData.append('fileList', params.file);
      apis.iconUpload(formData).then(res => {
        console.log("res: ", res);
        if (res.success && res.data && res.data.length > 0) {
          res.data.forEach(file => {
            newPermission.value.icon = file.innerUrl;
            submitData();
          });
        }
      });
    };
    const loadPage = () => {
      data.loading = true;
      apis.permissonPage({
        ...data.queryParam
      }).then(res => {
        if (res.success) {
          data.tableData = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    const loadMenuList = () => {
      apis.menuList().then(res => {
        if (res.success) {
          data.menuList = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const showDialog = row => {
      loadMenuList();
      if (row && row.id) {
        // 编辑
        data.isEdit = true;
        newPermission.value = row;
      } else {
        // 新增
        data.isEdit = false;
        newPermission.value = {
          menuType: 1
        };
      }
      data.addDialogShow = true;
    };
    const canUpdateState = async (row, state) => {
      let can = true;
      // 具有启动状态的子节点，不能禁用
      if (state == 0 && row.children && row.children.length > 0) {
        for (var i = 0; i < row.children.length; i++) {
          if (row.children[i].status == 1) {
            can = false;
            ElMessage.warning('具有启动状态的子节点，不能禁用');
            return;
          }
        }
      }
      // 父节点禁用，子节点不能启用
      if (state == 1 && row.parentId) {
        await apis.permissionById({
          id: row.parentId
        }).then(res => {
          if (res.success) {
            if (res.data.status == 0) {
              ElMessage.warning('父节点禁用，子节点不能启用');
              can = false;
            }
          } else {
            ElMessage.error('查询父节点信息失败');
            can = false;
          }
        });
      }
      return can;
    };
    const handleState = async (row, state) => {
      const can = await canUpdateState(row, state);
      if (can) {
        apis.updateStatus({
          id: row.id,
          status: state
        }).then(res => {
          if (res.success) {
            loadPage();
            ElMessage.success('权限状态修改成功');
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    };
    const onChange = () => {
      data.iconChange = true;
    };
    const onRemove = () => {
      data.iconChange = false;
    };
    const resetForm = () => {
      data.queryParam = {};
      loadPage();
    };
    onMounted(() => {
      loadPage();
    });
    return {
      ...toRefs(data),
      addForm,
      newPermission,
      upload,
      submit,
      loadPage,
      showDialog,
      handleState,
      resetForm,
      fileUpload,
      onChange,
      onRemove
    };
  }
});